import { makeSchedulable, makeTimeAllocable, SchedulablesController } from "./schedulable_helpers";

export default makeTimeAllocable(makeSchedulable(class extends SchedulablesController {
  connect() {
    this.preConnect && this.preConnect();
    this.openAllocationForm                 = this.openAllocationForm.bind(this);
    this.replaceTimeAllocationContainerWith = this.replaceTimeAllocationContainerWith.bind(this);
    this.refreshTable                       = this.refreshTable.bind(this);
    App.TimeEntries.addToAfterTimeLog(this.refreshTable);
  }

  disconnect() {
    App.TimeEntries.removeFromAfterTimeLog(this.refreshTable);
  }

  refreshTable(event) {
    event && event.preventDefault && event.preventDefault();
    this.getTimeAllocContainerFrom(this.timeAllocationURL);
  }

  openAllocationForm(event) {
    event.preventDefault();
    this.getTimeAllocContainerFrom(this.editURL);
  }

  //
  // GETTERS AND SETTERS
  //

  get editURL() {
    return this.data.get("time-allocator-edit-url");
  }
}));



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-time-allocation-table-controller.js